import { render, staticRenderFns } from "./admin.vue?vue&type=template&id=af3843b2&scoped=true&"
import script from "./admin.vue?vue&type=script&lang=ts&"
export * from "./admin.vue?vue&type=script&lang=ts&"
import style0 from "./admin.vue?vue&type=style&index=0&id=af3843b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af3843b2",
  null
  
)

export default component.exports